module.exports = __webpack_public_path__ + "img/moo-logo-stacked-img-desktop.d84c691b.svg";